'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var mergeOptions = require('merge-options');

var pipe = require('it-pipe');

var _require = require('streaming-iterables'),
    tap = _require.tap;

var oldPeerLRU = require('./old-peers');

var _require2 = require('../constants'),
    defaultOptions = _require2.METRICS;

var Stats = require('./stats');

var initialCounters = ['dataReceived', 'dataSent'];
var directionToEvent = {
  in: 'dataReceived',
  out: 'dataSent'
};

var Metrics = /*#__PURE__*/function () {
  /**
   *
   * @param {object} options
   * @param {number} options.computeThrottleMaxQueueSize
   * @param {number} options.computeThrottleTimeout
   * @param {Array<number>} options.movingAverageIntervals
   * @param {number} options.maxOldPeersRetention
   */
  function Metrics(options) {
    _classCallCheck(this, Metrics);

    this._options = mergeOptions(defaultOptions, options);
    this._globalStats = new Stats(initialCounters, this._options);
    this._peerStats = new Map();
    this._protocolStats = new Map();
    this._oldPeers = oldPeerLRU(this._options.maxOldPeersRetention);
    this._running = false;
    this._onMessage = this._onMessage.bind(this);
  }
  /**
   * Must be called for stats to saved. Any data pushed for tracking
   * will be ignored.
   */


  _createClass(Metrics, [{
    key: "start",
    value: function start() {
      this._running = true;
    }
    /**
     * Stops all averages timers and prevents new data from being tracked.
     * Once `stop` is called, `start` must be called to resume stats tracking.
     */

  }, {
    key: "stop",
    value: function stop() {
      this._running = false;

      this._globalStats.stop();

      var _iterator = _createForOfIteratorHelper(this._peerStats.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var stats = _step.value;
          stats.stop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this._protocolStats.values()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _stats = _step2.value;

          _stats.stop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    /**
     * Gets the global `Stats` object
     * @returns {Stats}
     */

  }, {
    key: "global",
    get: function get() {
      return this._globalStats;
    }
    /**
     * Returns a list of `PeerId` strings currently being tracked
     * @returns {Array<string>}
     */

  }, {
    key: "peers",
    get: function get() {
      return Array.from(this._peerStats.keys());
    }
    /**
     * Returns the `Stats` object for the given `PeerId` whether it
     * is a live peer, or in the disconnected peer LRU cache.
     * @param {PeerId} peerId
     * @returns {Stats}
     */

  }, {
    key: "forPeer",
    value: function forPeer(peerId) {
      var idString = peerId.toB58String();
      return this._peerStats.get(idString) || this._oldPeers.get(idString);
    }
    /**
     * Returns a list of all protocol strings currently being tracked.
     * @returns {Array<string>}
     */

  }, {
    key: "protocols",
    get: function get() {
      return Array.from(this._protocolStats.keys());
    }
    /**
     * Returns the `Stats` object for the given `protocol`.
     * @param {string} protocol
     * @returns {Stats}
     */

  }, {
    key: "forProtocol",
    value: function forProtocol(protocol) {
      return this._protocolStats.get(protocol);
    }
    /**
     * Should be called when all connections to a given peer
     * have closed. The `Stats` collection for the peer will
     * be stopped and moved to an LRU for temporary retention.
     * @param {PeerId} peerId
     */

  }, {
    key: "onPeerDisconnected",
    value: function onPeerDisconnected(peerId) {
      var idString = peerId.toB58String();

      var peerStats = this._peerStats.get(idString);

      if (peerStats) {
        peerStats.stop();

        this._peerStats.delete(idString);

        this._oldPeers.set(idString, peerStats);
      }
    }
    /**
     * Takes the metadata for a message and tracks it in the
     * appropriate categories. If the protocol is present, protocol
     * stats will also be tracked.
     *
     * @private
     * @param {object} params
     * @param {PeerId} params.remotePeer Remote peer
     * @param {string} [params.protocol] Protocol string the stream is running
     * @param {string} params.direction One of ['in','out']
     * @param {number} params.dataLength Size of the message
     * @returns {void}
     */

  }, {
    key: "_onMessage",
    value: function _onMessage(_ref) {
      var remotePeer = _ref.remotePeer,
          protocol = _ref.protocol,
          direction = _ref.direction,
          dataLength = _ref.dataLength;
      if (!this._running) return;
      var key = directionToEvent[direction];
      var peerStats = this.forPeer(remotePeer);

      if (!peerStats) {
        peerStats = new Stats(initialCounters, this._options);

        this._peerStats.set(remotePeer.toB58String(), peerStats);
      } // Peer and global stats


      peerStats.push(key, dataLength);

      this._globalStats.push(key, dataLength); // Protocol specific stats


      if (protocol) {
        var protocolStats = this.forProtocol(protocol);

        if (!protocolStats) {
          protocolStats = new Stats(initialCounters, this._options);

          this._protocolStats.set(protocol, protocolStats);
        }

        protocolStats.push(key, dataLength);
      }
    }
    /**
     * Replaces the `PeerId` string with the given `peerId`.
     * If stats are already being tracked for the given `peerId`, the
     * placeholder stats will be merged with the existing stats.
     * @param {PeerId} placeholder A peerId string
     * @param {PeerId} peerId
     */

  }, {
    key: "updatePlaceholder",
    value: function updatePlaceholder(placeholder, peerId) {
      if (!this._running) return;
      var placeholderStats = this.forPeer(placeholder);
      var peerIdString = peerId.toB58String();
      var existingStats = this.forPeer(peerId);
      var mergedStats = placeholderStats; // If we already have stats, merge the two

      if (existingStats) {
        // If existing, merge
        mergedStats = Metrics.mergeStats(existingStats, mergedStats); // Attempt to delete from the old peers list just in case it was tracked there

        this._oldPeers.delete(peerIdString);
      }

      this._peerStats.delete(placeholder.toB58String());

      this._peerStats.set(peerIdString, mergedStats);

      mergedStats.start();
    }
    /**
     * Tracks data running through a given Duplex Iterable `stream`. If
     * the `peerId` is not provided, a placeholder string will be created and
     * returned. This allows lazy tracking of a peer when the peer is not yet known.
     * When the `PeerId` is known, `Metrics.updatePlaceholder` should be called
     * with the placeholder string returned from here, and the known `PeerId`.
     *
     * @param {Object} options
     * @param {{ sink: function(*), source: function() }} options.stream A duplex iterable stream
     * @param {PeerId} [options.peerId] The id of the remote peer that's connected
     * @param {string} [options.protocol] The protocol the stream is running
     * @returns {string} The peerId string or placeholder string
     */

  }, {
    key: "trackStream",
    value: function trackStream(_ref2) {
      var stream = _ref2.stream,
          remotePeer = _ref2.remotePeer,
          protocol = _ref2.protocol;
      var metrics = this;
      var _source = stream.source;
      stream.source = tap(function (chunk) {
        return metrics._onMessage({
          remotePeer: remotePeer,
          protocol: protocol,
          direction: 'in',
          dataLength: chunk.length
        });
      })(_source);
      var _sink = stream.sink;

      stream.sink = function (source) {
        return pipe(source, tap(function (chunk) {
          return metrics._onMessage({
            remotePeer: remotePeer,
            protocol: protocol,
            direction: 'out',
            dataLength: chunk.length
          });
        }), _sink);
      };

      return stream;
    }
    /**
     * Merges `other` into `target`. `target` will be modified
     * and returned.
     * @param {Stats} target
     * @param {Stats} other
     * @returns {Stats}
     */

  }], [{
    key: "mergeStats",
    value: function mergeStats(target, other) {
      target.stop();
      other.stop(); // Merge queues

      target._queue = [].concat(_toConsumableArray(target._queue), _toConsumableArray(other._queue)); // TODO: how to merge moving averages?

      return target;
    }
  }]);

  return Metrics;
}();

module.exports = Metrics;